import { CAS_LOGOUT_URL } from "@/modules/constants";

export default (): string => (window.location.href = CAS_LOGOUT_URL);
